import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DeleteConfirmDialog = ({ open, onClose, onConfirm, usuarioId }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle
        sx={{
          backgroundColor: "#d9534f",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontFamily: "Montserrat-Bold",
          fontSize: "1rem",
          px: 3,
          py: 2,
        }}
      >
        Confirmar eliminación
        <IconButton onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 3, mt: 2 }}>
        <Typography
          sx={{
            fontFamily: "Montserrat-Regular",
            fontSize: "0.95rem",
            color: "#334155",
          }}
        >
          ¿Deseas eliminar al usuario <strong>{usuarioId}</strong>? 
          Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" sx={btnStyles}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            ...btnStyles,
            backgroundColor: "#d9534f",
            "&:hover": { backgroundColor: "#c84541" },
          }}
        >
          Eliminar definitivamente
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const btnStyles = {
  textTransform: "none",
  fontFamily: "Montserrat-Medium",
  borderRadius: "8px",
  px: 2.5,
  boxShadow: "none",
};

export default DeleteConfirmDialog;